import { render, staticRenderFns } from "./OpportunitiesWorkTable.vue?vue&type=template&id=0bfe3e5b&scoped=true&"
import script from "./OpportunitiesWorkTable.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesWorkTable.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesWorkTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OpportunitiesWorkTable.vue?vue&type=style&index=1&id=0bfe3e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe3e5b",
  null
  
)

export default component.exports